<template>
  <v-dialog
    v-model="dialog"
    persistent
    :max-width="options.width"
    @keydown.esc="cancel"
    v-bind:style="{zIndex: options.zIndex}"
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <baseModal>

      <v-btn
        slot="positive-button"
        dark text class="orange--text text-h6 font-weight-bold" @click.native="agree">등록</v-btn>

      <v-btn
        v-if="index > -1"
        slot="func-button"
        dark text class="pink--text text--lighten-2 text-h6" @click.native="remove">삭제</v-btn>

      <v-btn
        slot="negative-button"
        dark text class="white--text subheading" @click.native="cancel">취소</v-btn>

      <v-btn
        slot="star-area"
        icon
        @click.native="form.isStar = !form.isStar"
      >
        <v-icon
          v-if="!form.isStar"
          color="grey lighten-1"
        >
          mdi-star-outline
        </v-icon>
        <v-icon
          v-else
          color="yellow"
        >
          mdi-star
        </v-icon>
      </v-btn>

      <v-toolbar-title
        slot="title-area"
        class="white--text">{{ title }}</v-toolbar-title>

      <!-- 중요: 상단 툴바 타이틀을 고정시키기 위해 아래처럼 v-card에 max-height를 주면 된다 -->
      <!-- <v-card
        slot="content"
        tile
        elevation="0"
        class="overflow-y-auto py-2 px-3"
        :max-height="options.height"
      >
        <v-card-text> -->

      <!-- 상단 툴바를 고정시키지 않으려면 아래 주석을 푼다. 하단의 태그 끝에도 주석을 풀어야 한다. -->
      <v-card-text
        slot="content"
        class="pb-0"
      >
        <v-container fluid class="pb-0"><!-- 여기까지 적용 -->

          <v-row no-gutters>

            <v-col v-show="index > -1" cols="12" xs="12">
              <v-alert type="info" dense text class="text-body-2">
                일부입금/지체/감면이 있는 경우 금액,일자 등을 수정/삭제하여 실수금 형태로 관리하십시오.
              </v-alert>
            </v-col>
            <v-col cols="12" xs="12">

              <v-text-field
                v-model.trim="article.teamName"
                label="담당부서"
                readonly
              >
                <template v-slot:prepend>
                  <v-icon
                    :color="article.teamColorOrigin"
                  >mdi-account-group</v-icon>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="5">
              <v-select
                v-model="form.gubun1"
                :items="sugumCates"
                label="항목"
                dense
                menu-props="auto"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="2">
              <v-tooltip bottom color="primary">
                <template v-slot:activator="{ on }">
                  <v-icon
                    small
                    v-on="on"
                    class="ml-3 pt-3"
                  >mdi-help-circle-outline</v-icon>
                </template>
                <span>수금항목의 추가, 변경, 삭제는 [관리자>카테고리관리]에서 가능합니다.</span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" xs="12" sm="5">
              <v-select
                v-model="form.status"
                :items="manageStatus"
                label="관리상태"
                dense
                menu-props="auto"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="6">
              <v-menu
                ref="date1Selector"
                v-model="date1Selector"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model.trim="form.date1"
                    label="일자"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    style="width: 200px;"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.date1"
                  locale="ko"
                  @change="saveDate1"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" xs="12" sm="6">
              <v-text-field
                ref="numStr2"
                v-model.trim="form.str2"
                v-validate="'required|max:15|is_not:0'"
                :error-messages="errors.collect('str2Sugum')"
                data-vv-name="str2Sugum"
                required
                label="*금액"
                maxlength="15"
                suffix="원"
                @keypress="preventComma"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12">
              <v-select
                v-model="relClientIds"
                :items="relClients"
                :menu-props="{ bottom: true, offsetY: true, maxHeight: '250' }"
                label="수금대상자"
                multiple
                no-data-text="연계 의뢰인이 없습니다"
                dense
                style="font-size: 0.785rem !important"
                :readonly="rcReadOnly"
                @change="changeRelClient"
              >
                <template v-slot:selection="{ item }">
                  <v-chip small>
                    <span>{{ item.name }}</span>
                  </v-chip>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="6">
              <v-select
                v-model="form.gubun2"
                :items="receipts"
                label="영수증"
                menu-props="auto"
                style="width: 200px;"
                class="pt-3"
                @change="changeReceipt"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="6">
              <v-menu
                ref="date2Selector"
                v-model="date2Selector"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model.trim="form.date2"
                    :disabled="showReceipt"
                    label="발행일"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    style="width: 200px;"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.date2"
                  locale="ko"
                  @change="saveDate2"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" xs="12">
              <v-textarea
                ref="txt1"
                v-model="form.str1"
                outlined
                label="내용"
                placeholder="입력하세요"
                no-resize
                rows="5"
                counter="200"
                :rules="[rules.txtCounter]"
                @update:error="chkValidate = false"
                class="mt-5"
              ></v-textarea>
            </v-col>
            <v-col cols="12" xs="12">
              <v-alert
                border="left"
                outlined
                type="info"
                dense
                class="text-body-2"
              >
                {{ viewParentInfo }}
                <v-tooltip color="info" bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      small color="primary lighten-2"
                      @click="gotoDetail"
                      class="ml-1"
                    >mdi-launch</v-icon>
                  </template>
                  <span>바로가기</span>
                </v-tooltip>
              </v-alert>
            </v-col>
            <!-- <v-col cols="12" v-show="index > -1" class="py-0">
              <v-card
                tile
                elevation="0"
                class="ma-0 pa-0"
              >
                <v-card-actions class="ma-0 pa-0">
                  <v-btn small text icon color="primary" disabled>
                    <v-icon small>print</v-icon>
                  </v-btn>
                  <v-btn small text icon color="primary" disabled>
                    <v-icon small>get_app</v-icon>
                  </v-btn>
                  <v-btn small text icon color="primary" disabled>
                    <v-icon small>phone_iphone</v-icon>
                  </v-btn>
                  <v-btn small text icon color="primary" disabled>
                    <v-icon small>local_post_office</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <span class="text-caption mr-2">{{ viewWname }}</span><span class="text-caption">{{ viewUpdatedAt }}</span>
                </v-card-actions>
              </v-card>
            </v-col> -->
            <v-col cols="12">
              <div class="mb-8"></div>
            </v-col>

          </v-row>

        <!-- 상단 타이틀 고정을 풀때 사용 -->
        </v-container>
      </v-card-text>

        <!-- 상단 타이틀 고정시 사용 -->
        <!-- </v-card-text>
      </v-card> -->

    </baseModal>

  </v-dialog>
</template>

<script>
import ko from 'vee-validate/dist/locale/ko'
import baseModal from '@/components/common/BaseModal' // 기본 다이얼로그

// 구분: filters
import numberFormat from '@/filters/numberFormat' // number-format
import numberFormatR from '@/filters/numberFormatR' // reverse number-format
import preventComma from '@/filters/preventComma' // keypress event 에서 쉼표막기
import strDateFormat from '@/filters/strDateFormat'

export default {
  components: {
    baseModal
  },

  props: [ 'article' ],

  $_veeValidate: {
    validator: 'new'
  },

  data: () => ({
    // 구분: 다이얼로그 관련
    dialog: false,
    resolve: null,
    reject: null,
    title: null,
    options: {
      color: 'primary',
      width: 770,
      height: 750,
      zIndex: 200
    },
    // 구분: Form 관련
    form: {
      id: 0,
      relClientInfos: [], // 연계 의뢰인 정보 배열
      teamId: 1, // 기본팀이 초기값
      type: 24, // 수금
      depth: 2,
      pId: 0,
      pType: 1, // 소송(1), 자문(2)
      pInfo: '', // 정보위치(부모의 정보 중 보여줄 정보 이름)
      rId: 0,
      rType: 3, // 인명부
      rInfo: '',
      isStar: 0,
      isSchedule: 1,
      subtype: 1, // 등록을 제외한 업무는 1로 세팅(등록은 자동입력데이터임)
      gubun1: '', // 카테고리관리 > 수금항목에서 가져온다(이자리는 항상 카테고리)
      gubun2: '미발행',
      gubun3: '', // [2021.3.3] 수금관리상태 문자열 추가
      status: 1, // 관리상태: 대기/입금
      date1: '', // 일자
      date2: '', // 발행일
      str1: '', // 내용
      str2: '0', // 금액
      parentInfo: '' // [2021.3.23] 부모정보 문자열
    },
    // 구분: 중요: 연계의뢰인 리스트
    relClients: [
      { text: '구분안함', value: 0, name: '구분안함' }
    ],
    // 구분: 중요: 선택한 연계 의뢰인 배열
    relClientIds: [ 0 ],
    // 구분: 중요: 업무대상자 셀렉트 읽기모드 여부
    rcReadOnly: false,
    // 구분: 수금유형(gubun1) - 카테고리
    sugumCates: [],
    // 구분: 영수증(gubun2)
    receipts: [
      { text: '미발행', value: '미발행' },
      { text: '세금계산서', value: '세금계산서' },
      { text: '현금영수증', value: '현금영수증' }
    ],
    // 구분: 수금관리상태(status) [2021.3.3] 카테고리에서 가져오게 전환
    manageStatus: [],
    // 구분:
    index: -1, // !! 수정 인덱스
    // 구분: _veeValidate dictionary
    dictionary: {
      messages: ko.messages,
      attributes: {
        str2Sugum: '금액'
      }
    },
    // 구분: 입력 검증
    rules: {
      txtCounter: v => v.length <= 200 || '200자 이하의 내용을 입력해 주세요'
    },
    // 구분: txt1 유효성 체크
    chkValidate: true,
    // 구분: 일자, 발행일
    date1Selector: false, // 일자 셀렉터
    date2Selector: false, // 발행일 셀렉터
    // 구분: 수정시 처리자와 최종업데이트 정보
    viewWname: '',
    viewUpdatedAt: '',
    // 구분: 발행일 보이기 여부
    showReceipt: true,
    // 구분: 바로가기에 보여줄 부모 정보
    viewParentInfo: ''
  }),

  mounted () {
    this.$validator.localize('ko', this.dictionary)

    // !! 보수유형/수금항목은 관리자 > 카테고리에서 패칭한다.
    this.setCates('11').then(({ cates }) => {
      if (cates && cates.length > 0) {
        this.sugumCates = cates.map(c => c.gubun1)
        this.form.gubun1 = this.sugumCates[0] // 초기값 지정
      } else {
        this.sugumCates = []
      }
    })
  },

  watch: {
    // !![2021.3.15] str2 수정
    'form.str2': {
      handler: function (val, oldVal) {
        if (!val) {
          this.form.str2 = '0'
          this.$refs.numStr2.lazyValue = '0'
        } else {
          if (val.length > 1 && val[0] === '0') {
            this.form.str2 = val.replace(/(^0+)/, '')
          }
          this.form.str2 = numberFormatR(this.form.str2)
          this.form.str2 = numberFormat(this.form.str2)

          if (!/^\d{1,3}(,\d{3})*$/gi.test(this.form.str2)) {
            this.form.str2 = oldVal
            this.$refs.numStr2.lazyValue = oldVal
          }
        }
      }
    }
  },

  methods: {
    numberFormat,
    numberFormatR,
    preventComma,
    dummy () {
      console.log('dummy test')
    },
    sbpop (e) {
      // 서버에서 수신받은 에러는 router 에서 가로채기 하므로 띄우지 않도록 if (!e.response) 를 검사한다.
      if (!e.response) this.$store.commit('SB_POP', { msg: e.message })
    },
    // !!중요: 재귀적으로 부모의 $refs 를 탐색하여 target 객체를 찾아 리턴한다.
    // 주로 팝업을 검색하는데 사용!
    async findParentRefs (parent, target) {
      try {
        for (let key in parent.$refs) {
          if (key === target) { // 찾은경우
            return parent.$refs[key]
          }
        }
        // 못찾은 경우 - 부모가 또 있으면 올라간다.
        if (parent.$parent) {
          return await this.findParentRefs(parent.$parent, target)
        } else {
          return null // 못찾으면 null 리턴
        }
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 초기화
    async initDialog () {
      // validation 초기화
      this.$validator.reset()

      this.form.id = 0
      this.form.relClientInfos = [] // !! 연계의뢰인 정보 배열
      this.form.teamId = 1 // 기본팀을 기본값으로
      this.form.pId = 0 // 부모 아이디
      this.form.pType = 1 // 부모 타입: 소송(1), 자문(2)
      this.form.pInfo = '' // 정보위치(부모의 정보 중 보여줄 정보 이름)
      this.form.rId = 0
      this.form.rType = 3 // 업무대상자는 인명부(3)의 의뢰인
      this.form.rInfo = ''
      this.form.gubun1 = this.sugumCates[0]
      this.form.gubun2 = '미발행'
      this.form.gubun3 = '' // [2021.3.3] 수금관리상태 문자열 추가
      this.form.status = 1
      this.form.isStar = 0
      this.form.isSchedule = 1 // 일정표시여부
      this.form.date1 = this.$moment().format('YYYY-MM-DD') // 일시 초기값(오늘)
      this.form.date2 = this.$moment().format('YYYY-MM-DD') // 발행일 초기값(오늘)
      this.form.str1 = '' // 내용
      this.form.str2 = '0' // 금액
      this.form.subtype = 1 // 이걸 해줘야 한다!
      this.form.parentInfo = ''

      // !! 연계의뢰인 셀렉트 초기화
      this.relClients = [
        { text: '구분안함', value: 0, name: '구분안함' }
      ]
      // !! 연계의뢰인 선택 초기화
      this.relClientIds = [ 0 ]
      // !! 셀렉트 읽기모드 여부
      this.rcReadOnly = false

      this.showReceipt = true
      this.index = -1 // 수정용 인덱스 초기화
    },
    async open (title, options, index = -1, obj = {}, relClients) {
      try {
        this.dialog = true
        this.title = title
        this.options = Object.assign(this.options, options)

        // console.log(this.article) // !! props 로 넘어온 부모 데이터

        // !! [2021.3.3 추가] 수금관리상태 카테고리 만들기
        this.setCates('23').then(({ cates }) => {
          if (cates && cates.length > 0) {
            this.manageStatus.push(...cates.map(c => ({ text: c.gubun1, value: c.num })))
          }
        })

        // 초기화
        await this.initDialog()

        // !! 연계 의뢰인 셀렉트 매칭
        this.relClients.push(...relClients)

        // !! 아래 3개는 부모로부터 넘겨받은 데이터로 매칭하자(뭐 이렇게 하지 않아도 되는데)
        this.form.teamId = this.article.teamId
        this.form.pId = this.article.id
        this.form.pType = this.article.type1

        // !! 소송/자문에 따른 부모 정보 - 2021.3.19 수정
        if (this.article.type1 === 1) { // 소송인 경우
          this.viewParentInfo = `${this.article.courtName} ${this.article.caseNum}${this.article.manageNum ? `/${this.article.manageNum}` : ''}`
          this.form.parentInfo = this.article.caseNum
        } else { // 자문
          this.viewParentInfo = `${this.article.manageNum}`
          this.form.parentInfo = this.article.manageNum
        }

        // 중요:[2021.3.19] 부모정보의 객체를 문자열로 변환해서 this.form.pInfo 에 담는다.
        this.form.pInfo = JSON.stringify(this.article.pInfo)

        // 참고: 편집 모드인 경우 - 넘어온 객체를 this.form 에 복사
        if (index > -1) {
          // console.log(obj) // 파라미터로 넘어온 업무
          this.index = index

          this.form.id = obj.id

          // !! 업무대상자인 인명부(의뢰인) 정보가 있는 경우 처리
          if (obj.rId) {
            // console.log(obj.rId)
            // !! rId, rType, rInfo 를 채운다
            this.form.rId = obj.rId
            this.form.rType = obj.rType
            this.form.rInfo = obj.rInfo

            // 1) 셀렉트 고정
            this.relClients = [
              { text: obj.rInfo, value: obj.rId, name: obj.rInfo }
            ]
            // 2) 셀렉트 선택 & readOnly
            this.relClientIds = [ obj.rId ]
            this.rcReadOnly = true
            // 3) 폼의 연계의뢰인 정보 배열은 초기화 시키고
            this.form.relClientInfos = []
            // 4) 폼의 정보 고정
            this.form.relClientInfos.push({ id: obj.rId, name: obj.rInfo })
          }

          this.form.gubun1 = obj.gubun1
          this.form.gubun2 = obj.gubun2
          this.form.gubun3 = obj.gubun3 // [2021.3.3] 수금관리상태 문자열 추가
          this.form.status = obj.status
          this.form.subtype = obj.subtype
          this.form.isStar = obj.isStar

          this.form.str1 = obj.str1 // 내용
          this.form.str2 = obj.str2.toString() // !! 계산된 금액(수정시 정수형을 문자열로 변환해야 한다.)

          this.form.date1 = obj.date1.substr(0, 10) // 일자 처리
          if (obj.date2) this.form.date2 = obj.date2.substr(0, 10) // 발행일 처리

          if (obj.gubun2 === '미발행') this.showReceipt = true
          else this.showReceipt = false

          // 참고: 편집일때는 처리자와 업데이트 일자를 보여준다.
          this.viewWname = obj.wname
          this.viewUpdatedAt = strDateFormat(obj.updatedAt) // 필터로 쓰진 않고 함수로 사용
        }

        // 프로미스를 리턴하면서 resolve를 매칭하고있다.
        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 등록
    async agree () {
      try {
        // 참고: 입력값 검증
        let isValidate = await this.$validator.validateAll()
        if (!isValidate) throw new Error('입력값을 확인해 주세요')

        // 중요: textarea 의 글자수가 200 이하로 조정되면 여기서 체크해서 처리한다.
        if (this.rules.txtCounter(this.$refs.txt1.value) === true) {
          this.chkValidate = true
        }
        if (!this.chkValidate) throw new Error('저장할 수 없습니다. 내용 항목의 글자수를 줄여주세요.')

        // !! 한번더 - 금액에 대해 숫자만 남긴다
        // !![2021.3.15] 수정
        // this.form.str2 = this.form.str2.replace(/[^0-9]/g, '')

        // 일자 처리 - 시분초를 붙여준다.(00:00:01 로 해서 일정에서 밑에 위치할 것이다.)
        // this.form.date1 = `${this.form.date1.substr(0, 10)} 00:00:01`
        // !!중요:[2021.4.8] 일시 수정 - 00:19:01 로 변경
        this.form.date1 = `${this.form.date1.substr(0, 10)} 00:19:01`

        // 발행일 처리 - 미발행인 경우 null
        this.form.date2 = (this.form.gubun2 === '미발행') ? null : `${this.form.date2.substr(0, 10)} 00:00:01`

        // 중요: [2021.3.3] 수금관리상태의 변경으로 추가됨
        // 선택한 관리상태의 정수값(status)로 문자열값을 만들어준다
        this.form.gubun3 = this.manageStatus.find(s => s.value === this.form.status).text

        // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

        // 리턴객체
        let resolve = {
          isDeleted: false, // 부모가 삭제되었는지 여부
          teamError: false, // 부모의 팀에러
          chInfo: null, // 부모의 에러에 대한 메시지
          rsMsg: '' // resolve 메시지
        }

        // !! DB 입력 처리 (등록/수정 동일하게 처리)
        const { data } = await this.$axios.post(`lawork/case/setRelSugum`, this.form)
        if (!data.success) throw new Error(`오류가 발생하였습니다: ${data.message}`)
        // 리턴값으로 resolve 채우기
        resolve.isDeleted = data.isDeleted
        resolve.teamError = data.teamError
        resolve.chInfo = data.chInfo
        resolve.rsMsg = 'success'

        // 등록 후
        await this.initDialog()
        this.resolve(resolve) // this.resolve(true)
        this.dialog = false
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 취소
    async cancel () {
      try {
        await this.initDialog() // 초기화
        this.resolve(false) // reject() 가 아니라 resolve(false)로 던져야 한다.
        this.dialog = false
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 삭제
    async remove () {
      try {
        if (!this.form.id) throw new Error(`잘못된 요청입니다.`)

        // 중요: 재귀적으로 부모의 $refs 에서 팝업 컴포넌트 객체를 얻는다.
        const target = 'confirmDialog'
        const pop = await this.findParentRefs(this.$parent, target)
        if (!pop) throw new Error('팝업창을 열 수 없습니다.')
        // 찾았으면 팝업을 연다
        const msg = `정말 삭제하시겠습니까?<br>삭제된 데이터는 복구되지 않습니다.`
        if (await pop.open('삭제', msg, { color: 'error', width: 400 })) {
          // 리턴객체
          let resolve = {
            isDeleted: false, // 부모가 삭제되었는지 여부
            teamError: false, // 부모의 팀에러
            chInfo: null, // 부모의 에러에 대한 메시지
            rsMsg: '' // resolve 메시지
          }
          // const { data } = await this.$axios.get(`lawork/case/deleteLwcommon/${this.form.id}`)
          // !!2021.2.17 - POST 방식으로 변경하며 필요 데이터만 파라미터로 넘긴다!
          const params = {
            id: this.form.id,
            teamId: this.form.teamId,
            type: this.form.type,
            depth: this.form.depth,
            pId: this.form.pId,
            pType: this.form.pType,
            pInfo: this.form.parentInfo
          }
          const { data } = await this.$axios.post(`lawork/case/removeLwc`, params)
          if (!data.success) throw new Error(`오류가 발생하였습니다: ${data.message}`)
          // 리턴값으로 resolve 채우기
          resolve.isDeleted = data.isDeleted
          resolve.teamError = data.teamError
          resolve.chInfo = data.chInfo
          resolve.rsMsg = 'removed'

          await this.initDialog() // 초기화
          this.resolve(resolve) // this.resolve(true)
          this.dialog = false
        }
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 구분: 업무대상자 셀렉트 체인지 이벤트
    // '구분안함' 을 처리하는 것이 중요하다!
    async changeRelClient () {
      try {
        const index = this.relClientIds.indexOf(0)
        if (index === 0) {
          // 구분안함(0) 이 첫번째에 있으면 구분안함을 지워야 한다.
          this.relClientIds.splice(index, 1)
        } else if (index >= 0) {
          // 구분안함(0) 이 중간에 들어오면 모두 지우고 0을 넣어야 한다.
          this.relClientIds = [ 0 ]
        }

        // 선택된게 아무것도 없으면 구분안함(0)을 선택한다.
        if (this.relClientIds.length === 0) {
          this.relClientIds = [ 0 ]
        }

        // 폼의 연계의뢰인 정보 배열은 초기화 시키고
        this.form.relClientInfos = []

        // 구분안함이 아닌 항목이 선택되었으면. 첫번째 항목의 값은 1이 아니다.
        if (this.relClientIds[0] > 0) {
          for (let value of this.relClientIds) {
            // 선택된 의뢰인을 this.relClients 에서 찾아서 this.form.relClientInfos 에 넣는다
            const selected = this.relClients.find(rc => rc.value === value)
            this.form.relClientInfos.push({ id: selected.value, name: selected.name })
          }
        }
        // console.log(this.form.relClientInfos)
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 카테고리 패칭 함수 - 공통함수로 빼기 난해
    async setCates (type) {
      try {
        const { data } = await this.$axios.get(`admin/cate/getType/${type}`)
        if (!data.success) throw new Error(`list error: ${data.message}`)
        return { cates: data.cates }
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 일자 셀렉트 선택시 저장 함수
    async saveDate1 (date) {
      this.$refs.date1Selector.save(date)
    },
    // 발행일 셀렉트 선택시 저장 함수
    async saveDate2 (date) {
      this.$refs.date2Selector.save(date)
    },
    // 인명부 상세페이지 바로가기
    async gotoDetail () {
      this.dialog = false
      if (this.article.type1 === 1) { // 수금인 경우
        // !! 현재 경로가 case 디렉토리가 아닌 경우만 case/ 로 이동시킨다
        if (!(this.$router.history.current.path.indexOf('case') !== -1)) {
          this.$router.push(`/case/${this.article.id}`)
        }
      } else { // 자문일때
        // !! 현재 경로가 advice 디렉토리가 아닌 경우만 advice/ 로 이동시킨다
        if (!(this.$router.history.current.path.indexOf('advice') !== -1)) {
          this.$router.push(`/advice/${this.article.id}`)
        }
      }
    },
    // 영수증 셀렉트 변경
    async changeReceipt () {
      try {
        if (this.form.gubun2 === '미발행') { // 미발행 일때만 초기로
          this.form.date2 = this.$moment().format('YYYY-MM-DD')
        }
        this.showReceipt = this.form.gubun2 === '미발행'
      } catch (e) {
        this.sbpop(e)
      }
    }
  }
}
</script>
